<div class="container-fluid dashboard-container">

  <!-- Row 1: Summary Cards -->
  <div class="row mb-4 dashboard-row">
    <!-- Card 1: Active Cohorts -->
    <div class="col-12 col-sm-6 col-lg-3 mb-4 mb-lg-0 d-flex">
      <mat-card class="summary-card h-100 w-100">
        <mat-card-header>
          <mat-card-title class="custom-card-title">{{ activeCohortsStat.title }}</mat-card-title>
          <button mat-icon-button class="accordion-icon ms-auto">
             <mat-icon>more_vert</mat-icon> 
            </button>
        </mat-card-header>
        <mat-card-content> 
          <div class="chart-placeholder">(Bar Chart)</div>
           <div class="summary-details"> 
            <div class="summary-value-section"> 
              <div class="summary-label">{{ activeCohortsStat.summaryLabel }}</div> 
              <div class="summary-value">{{ activeCohortsStat.summaryValue }}</div> 
            </div> 
            <div class="summary-change-section"> 
              <div class="period-label">{{ activeCohortsStat.periodLabel }}</div>
               <div class="percentage-change" [ngClass]="getChangeClass(activeCohortsStat.changeDirection)">
                 <mat-icon>{{ getChangeIcon(activeCohortsStat.changeDirection) }}</mat-icon> 
                 <span>{{ activeCohortsStat.changePercentage }}%</span>
                 </div> 
                </div> 
              </div> 
            </mat-card-content>
      </mat-card>
    </div>
    <!-- Card 2: Sessions Complete -->
    <div class="col-12 col-sm-6 col-lg-3 mb-4 mb-lg-0 d-flex">
      <mat-card class="summary-card h-100 w-100">
        <mat-card-header> 
          <mat-card-title class="custom-card-title">{{ sessionsCompleteStat.title }}</mat-card-title> 
          <button mat-icon-button class="accordion-icon ms-auto"> 
            <mat-icon>more_vert</mat-icon> 
          </button> 
        </mat-card-header>
        <mat-card-content> 
          <div class="chart-placeholder">(Bar Chart)</div> 
          <div class="summary-details"> 
            <div class="summary-value-section"> 
              <div class="summary-label">{{ sessionsCompleteStat.summaryLabel }}</div> 
              <div class="summary-value">{{ sessionsCompleteStat.summaryValue }}</div> 
            </div> 
            <div class="summary-change-section"> 
              <div class="period-label">{{ sessionsCompleteStat.periodLabel }}</div> 
              <div class="percentage-change" [ngClass]="getChangeClass(sessionsCompleteStat.changeDirection)"> 
                <mat-icon>{{ getChangeIcon(sessionsCompleteStat.changeDirection) }}</mat-icon> 
                <span>{{ sessionsCompleteStat.changePercentage }}%</span> 
              </div> 
            </div> 
          </div> 
        </mat-card-content>
      </mat-card>
    </div>
    <!-- Card 3: Engagement Rate -->
    <div class="col-12 col-sm-6 col-lg-3 mb-4 mb-sm-0 d-flex">
      <mat-card class="summary-card h-100 w-100">
        <mat-card-header> 
          <mat-card-title class="custom-card-title">{{ engagementRateStat.title }}</mat-card-title> 
          <button mat-icon-button class="accordion-icon ms-auto"> 
            <mat-icon>more_vert</mat-icon> 
          </button> 
        </mat-card-header>
        <mat-card-content> 
          <div class="chart-placeholder">(Bar Chart)</div>
           <div class="summary-details"> 
            <div class="summary-value-section"> 
              <div class="summary-label">{{ engagementRateStat.summaryLabel }}</div> 
              <div class="summary-value">{{ engagementRateStat.summaryValue }}</div>
             </div>
              <div class="summary-change-section">
                 <div class="period-label">{{ engagementRateStat.periodLabel }}</div> 
                 <div class="percentage-change" [ngClass]="getChangeClass(engagementRateStat.changeDirection)">
                   <mat-icon>{{ getChangeIcon(engagementRateStat.changeDirection) }}</mat-icon> 
                   <span>{{ engagementRateStat.changePercentage }}%</span> 
                  </div> 
                </div> 
              </div> 
            </mat-card-content>
      </mat-card>
    </div>
    <!-- Card 4: Top Performing Courses -->
    <div class="col-12 col-sm-6 col-lg-3 d-flex">
      <mat-card class="summary-card top-courses-card h-100 w-100">
        <mat-card-header> <mat-card-title class="custom-card-title">{{ topPerformingStat.title }}</mat-card-title> <button mat-icon-button class="accordion-icon ms-auto"> <mat-icon>more_vert</mat-icon> </button> </mat-card-header>
        <mat-card-content> <ul class="top-courses-list"> <li *ngFor="let course of topPerformingStat.topCourses">{{ course.name }}</li> </ul> <div class="chart-overlap-container"> <div class="period-label chart-period-label">{{ topPerformingStat.periodLabel }}</div> <div class="chart-placeholder">(Line Graph)</div> </div> </mat-card-content>
      </mat-card>
    </div>
  </div> <!-- End of Row 1 -->

  <!-- Row 2: Courses List -->
  <div class="row">
    <div class="col-12">
    <mat-card class="courses-card" appearance="outlined">
      <mat-card-content>
        <!-- Courses Header & Search -->
        <div class="d-flex justify-content-between align-items-center mb-3 flex-wrap">
          <h2 class="mb-2 mb-md-0">Courses</h2>
          <mat-form-field appearance="outline" class="search-field ms-md-auto"> 
            <input matInput placeholder="Search here...">
            <mat-icon matSuffix>search</mat-icon> 
          </mat-form-field>
        </div>

        <!-- Courses Filters -->
        <div class="d-flex align-items-center gap-2 mb-3 flex-wrap courses-filters">
          <button mat-stroked-button [matMenuTriggerFor]="recentMenu" class="filter-button">
             <mat-icon>arrow_drop_down</mat-icon> 
             <span>Recent</span> 
            </button>
           <mat-menu #recentMenu="matMenu" class="filter-dropdown-menu"> 
            <button mat-menu-item>Last Added</button>
             <button mat-menu-item>Last Updated</button> 
             <button mat-menu-item>Most Active</button> 
            </mat-menu>
           <button mat-stroked-button [matMenuTriggerFor]="filterMenu" class="filter-button"> 
            <mat-icon>arrow_drop_down</mat-icon> 
            <span>Filter</span> 
          </button>
           <mat-menu #filterMenu="matMenu" class="filter-dropdown-menu"> 
            <button mat-menu-item>Status: Active</button>
             <button mat-menu-item>Status: Inactive</button>
              <button mat-menu-item>Bot Status: Linked</button> 
              <button mat-menu-item>Bot Status: Not Linked</button> 
            </mat-menu>
        </div>

        <!-- Static Course List Header - All Columns Restored -->
        <div class="course-list-header course-panel-header">
            <div class="course-header-col col-name">Course Name</div>
            <div class="course-header-col col-learners">Learners</div>
            <div class="course-header-col col-bot-status">Bot Linked</div>
            <div class="course-header-col col-enrollment">Enrollment</div>
            <div class="course-header-col col-label">Label</div>
            <div class="course-header-col col-status">Status</div>
            <div class="course-header-col col-edit"> </div> <!-- Alignment placeholder -->
        </div>

        <!-- Loading Indicator -->
        <div *ngIf="isLoading" class="loading-container"> <mat-spinner diameter="50"></mat-spinner> </div>

         <!-- Error Message -->
        <div *ngIf="error && !isLoading" class="error-container"> <mat-icon color="warn">error_outline</mat-icon> <span>{{ error }}</span> <button mat-stroked-button color="primary" (click)="loadCourses()">Retry</button> </div>

        <!-- Courses List - Accordion -->
        <div *ngIf="!isLoading && !error" class="course-list-container">
           <mat-accordion multi="true">
             <mat-expansion-panel *ngFor="let course of courses"
                                   (opened)="panelOpenState = true"
                                   (closed)="panelOpenState = false"
                                   hideToggle>
               <mat-expansion-panel-header>
                 <!-- Panel Header Content - All Columns Restored -->
                 <div class="course-panel-header">
                    <!-- Bar colour for course-->
                     <div class="bar-color">
                     <!-- <div class="mb-4 empty-user-box">
                         You can give this a specific height or min-height via CSS if needed
                             e.g., style="min-height: 70px;" (adjust value as needed) 
                           Non-breaking space to prevent collapsing 
                      </div> --> 
                     </div>
                    <!-- Course Name & Description -->
                    <div class="course-header-col col-name">
                       <span class="header-value course-title">{{ course.name }}</span>
                       <span class="header-sub-value lecturer-name">{{ course.description || 'No description' }}</span>
                    </div>
                    <!-- Learners -->
                     <div class="course-header-col col-learners">
                       <span class="header-value">N/A</span> <!-- Placeholder -->
                    </div>
                    <!-- Bot Status -->
                     <div class="course-header-col col-bot-status">
                       <span class="header-value status-not-linked">---</span> <!-- Placeholder -->
                    </div>
                     <!-- Enrollment (Using updatedAt as example) -->
                     <div class="course-header-col col-enrollment">
                       <span class="header-value">{{ course.updatedAt | date:'yyyy-MM-dd' }}</span>
                       <span class="header-sub-value enrollment-time">{{ course.updatedAt | date:'HH:mm' }}</span>
                    </div>
                    <!-- Label -->
                    <div class="course-header-col col-label">
                       <span class="header-value">---</span> <!-- Placeholder -->
                    </div>
                    <!-- Status -->
                    <div class="course-header-col col-status">
                       <span class="header-value status-text" [ngClass]="getStatusClass(course.enabled)">
                         {{ getStatusText(course.enabled) }}
                       </span>
                    </div>
                    <!-- Edit Course -->
                    <div class="course-header-col col-edit">
                       <button mat-button color="primary" class="edit-button" (click)="editCourse(course.id, $event)"> EDIT COURSE </button>
                    </div>
                 </div>
               </mat-expansion-panel-header>

               <!-- Panel Content -->
               <div class="course-details-content">
                 <strong>Description:</strong><br> {{ course.description || 'No additional details available.' }} <br><br>
                 <strong>Created:</strong> {{ course.createdAt | date:'medium' }} <br>
                 <strong>Updated:</strong> {{ course.updatedAt | date:'medium' }}
               </div>
             </mat-expansion-panel>

             <!-- No Courses Found Message -->
             <div *ngIf="!isLoading && !error && (!courses || courses.length === 0)" class="no-courses-message p-3 text-center text-muted">
                 No courses found matching your criteria.
             </div>
           </mat-accordion>
        </div>

        <!-- Create Button -->
        <div class="create-button-container d-flex justify-content-end py-3">
            <button mat-flat-button class="create-course-button" (click)="createNewCourse()"> Create New Course </button>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div> <!-- End Row 2 -->
</div> <!-- End Container -->